<template>
  <div class="page boss-page strategy-workbench-page">
    <van-nav-bar title="战略执行工作台" left-arrow fixed placeholder @click-left="$router.back()"/>

    <section class="summary">
      <div><b>{{ reviews.length }}</b><span>待复审草案</span></div>
      <div><b>{{ assignments.length }}</b><span>待分配任务</span></div>
      <div><b>{{ team.length }}</b><span>团队成员</span></div>
    </section>

    <section class="quick panel">
      <h2>快捷入口</h2>
      <button class="entry" @click="goProjects">
        <van-icon name="orders-o"/>
        <span><b>项目与任务</b><small>查看项目、复审 AI 草案、分配执行人</small></span>
        <em>进入</em>
      </button>
      <button class="entry" @click="goReviews">
        <van-icon name="todo-list-o"/>
        <span><b>日志复核</b><small>确认团队工作方向与执行质量</small></span>
        <em>进入</em>
      </button>
      <button class="entry" @click="goWorkPoints">
        <van-icon name="notes-o"/>
        <span><b>工作要点</b><small>检查任务是否已生成并采纳工作要点</small></span>
        <em>进入</em>
      </button>
    </section>

    <section class="block panel">
      <h2>我的待办</h2>
      <button v-for="x in reviews" :key="'r'+field(x,'id')" class="todo-item" @click="openProject(x)">
        <span><b>复审：{{ field(x, 'title') }}</b><small>{{ field(x, 'project_name') }}</small></span>
        <em>去复审</em>
      </button>
      <button v-for="x in assignments" :key="'a'+field(x,'id')" class="todo-item" @click="openProject(x)">
        <span><b>分配：{{ field(x, 'title') }}</b><small>{{ field(x, 'project_name') }}</small></span>
        <em>去分配</em>
      </button>
      <div v-if="!reviews.length && !assignments.length" class="empty-next">
        <van-empty description="暂无待复审或待分配任务"/>
        <van-button plain type="danger" size="small" @click="goProjects">去项目任务页查看链路</van-button>
      </div>
    </section>

    <section class="block panel">
      <h2>团队执行与能力</h2>
      <article v-for="x in team" :key="field(x,'employee_id')" class="team-item" @click="openGrowth(x)">
        <span><b>{{ field(x, 'employee_name') }}</b><small>{{ field(x, 'position_name') }}</small></span>
        <p>任务 {{ field(x, 'task_count') || 0 }} · 已完成 {{ field(x, 'completed_count') || 0 }} · 执行中要点
          {{ field(x, 'active_point_count') || 0 }}</p>
        <em>能力画像</em>
      </article>
      <div v-if="!team.length" class="empty-next">
        <van-empty description="暂无团队执行数据"/>
        <van-button plain type="danger" size="small" @click="goReviews">去日志复核查看团队提交</van-button>
      </div>
    </section>
  </div>
</template>

<script>
import api from '@/utils/coreapi';

export default {
  data() {
    return {reviews: [], assignments: [], team: []};
  },
  created() {
    this.load();
  },
  methods: {
    field(x, k) {
      return x[k] !== undefined ? x[k] : x[k.toUpperCase()];
    },
    async load() {
      try {
        const d = await api.supervisorStrategyWorkbench();
        this.reviews = d.pendingReviews || [];
        this.assignments = d.pendingAssignments || [];
        this.team = d.teamExecution || [];
      } catch (e) {
        this.$toast.fail(e.message);
      }
    },
    goProjects() {
      this.$router.push({name: 'BossProjectPortfolio'});
    },
    goReviews() {
      this.$router.push({name: 'SupervisorReviews'});
    },
    goWorkPoints() {
      this.$router.push({name: 'EfficiencyWorkPoints'});
    },
    openProject(x) {
      this.$router.push({name: 'BossProjectTaskPlanning', params: {id: this.field(x, 'project_id')}});
    },
    openGrowth(x) {
      this.$router.push({
        name: 'EfficiencyGrowth',
        query: {employeeId: this.field(x, 'employee_id'), employeeName: this.field(x, 'employee_name')}
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../boss/boss.less';
@import './supervisor.less';

.strategy-workbench-page {
  min-height: 100vh;
  margin: 0;
  padding-bottom: 1.2rem;
  background: #f6f7fb;
  color: #30313a;
}

.strategy-workbench-page > .van-nav-bar.van-nav-bar--fixed,
.strategy-workbench-page > .van-nav-bar,
.strategy-workbench-page /deep/ .van-nav-bar {
  top: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  width: 100vw !important;
  max-width: 100% !important;
  border-radius: 0 !important;
}

.summary {
  margin: .2rem .28rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #fff;
  border-radius: .16rem;
  box-shadow: 0 .05rem .2rem rgba(30, 35, 60, .06);
}

.summary div {
  padding: .25rem .08rem;
  text-align: center;
}

.summary b, .summary span {
  display: block;
}

.summary b {
  color: #c6282d;
  font-size: .4rem;
}

.summary span {
  color: #888;
  font-size: .22rem;
}

.panel {
  margin: .2rem .28rem 0;
  padding: .24rem .26rem;
  background: #fff;
  border-radius: .16rem;
  box-shadow: 0 .05rem .2rem rgba(30, 35, 60, .06);
}

.panel h2 {
  margin: 0 0 .14rem;
  font-size: .32rem;
  color: #30313a;
}

.entry {
  width: 100%;
  min-height: 1.2rem;
  padding: .2rem .06rem .2rem 0;
  display: flex;
  align-items: center;
  border: 0;
  border-top: 1PX solid #f0f0f0;
  text-align: left;
  background: #fff;
  cursor: pointer;
}

.entry:active {
  background: #fafafa;
}

.entry:first-of-type {
  border-top: 0;
}

.entry > .van-icon:first-child {
  width: .68rem;
  height: .68rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 .68rem;
  color: #c62828;
  font-size: .36rem;
  border-radius: .14rem;
  background: #fff5f5;
}

.entry:nth-child(3) > .van-icon:first-child {
  color: #2d9561;
  background: #eaf7f0;
}

.entry:nth-child(4) > .van-icon:first-child {
  color: #3c6fbf;
  background: #eef3ff;
}

.entry span {
  min-width: 0;
  margin-left: .18rem;
  flex: 1;
}

.entry b, .entry small {
  display: block;
}

.entry b {
  font-size: .29rem;
  color: #34364a;
}

.entry small {
  margin-top: .05rem;
  color: #8b8e9d;
  font-size: .22rem;
  line-height: 1.4;
}

.entry em {
  flex: 0 0 auto;
  min-width: .88rem;
  padding: .1rem .22rem;
  color: #fff;
  text-align: center;
  border-radius: .28rem;
  background: linear-gradient(135deg, #d32f2f, #b71c1c);
  font-size: .23rem;
  font-style: normal;
  font-weight: 500;
  box-shadow: 0 .04rem .12rem rgba(198, 40, 40, .25);
}

.todo-item {
  width: 100%;
  padding: .2rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .08rem .12rem;
  text-align: left;
  border: 0;
  border-top: 1PX solid #eee;
  background: #fff;
  cursor: pointer;
}

.todo-item:active {
  background: #fafafa;
}

.team-item {
  width: 100%;
  padding: .2rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .08rem .12rem;
  text-align: left;
  border-top: 1PX solid #eee;
  background: #fff;
}

.todo-item:first-of-type, .team-item:first-of-type {
  border-top: 0;
}

.todo-item span, .team-item > span {
  min-width: 0;
  flex: 1;
}

.todo-item b, .team-item b, .todo-item small, .team-item small {
  display: block;
}

.todo-item b, .team-item b {
  font-size: .28rem;
  color: #34364a;
}

.todo-item small, .team-item small {
  margin-top: .05rem;
  color: #8b8e9d;
  font-size: .23rem;
}

.todo-item em, .team-item em {
  flex: 0 0 auto;
  padding: .08rem .2rem;
  color: #c62828;
  border: 1PX solid #f0c8c8;
  border-radius: .24rem;
  background: #fff5f5;
  font-size: .22rem;
  font-style: normal;
}

.team-item {
  cursor: pointer;
}

.team-item p {
  width: 100%;
  margin: 0;
  padding-left: 0;
  color: #666;
  font-size: .23rem;
}

.empty-next {
  padding: .2rem 0 .1rem;
  text-align: center;
}

.empty-next /deep/ .van-button {
  margin-top: .12rem;
  border-radius: .08rem;
}
</style>



// WEBPACK FOOTER //
// src/views/efficiency/supervisor/StrategyWorkbench.vue